import { Component } from '@angular/core';

@Component({
  selector: 'lgb-comming-soon',
  standalone: false,
  templateUrl: './comming-soon.html',
  styleUrl: './comming-soon.css',
})
export class CommingSoon {

}
